export const SOCIAL_LINKS = {
  instagram: 'https://instagram.com/oroszcoaching',
  facebook:  'https://www.facebook.com/profile.php?id=61591510353025',
  messenger: 'https://m.me/61591510353025',
  email:     'info@oroszcoaching.hu',
  youtube:   null,
};
